// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__VKzWm","heading":"LoginForm_heading__1ncqN","input":"LoginForm_input__C4YBF","button":"LoginForm_button__hHec2","error":"LoginForm_error__Vt0Yt"};